module.exports = __webpack_public_path__ + "static/img/A128.afde77c9.jpg";